<template>
  <div class="register">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="90px"
      style="width: 100%; margin: 0 auto"
      :class="isShow"
    >
      <div>
        <h1 class="h2" style="font-size:20px;">2023年度人力资源服务机构100强 领奖登记</h1>
      </div>
     <el-form-item
        prop="CompanyName"
        label="公司名称"
        :rules="[
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '司名称长度在1到50个字符',
            trigger: 'blur',
          },
        ]"
      >
       <!--   <el-select
          v-model="ruleForm.CompanyName"
          placeholder="请输入公司名称"
          :loading="selectLoading"
          filterable
          clearable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
        >
          <el-option
            v-for="item in companyList"
            :key="item.companyCode"
            :label="item.companyName"
            :value="item.companyName"
          ></el-option>
        </el-select> -->
        <el-input
          placeholder="公司名称"
          v-model="ruleForm.CompanyName"
          clearable
          maxlength="100"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="ApplyAwardTypeNames"
        label="奖项"
        :rules="[{ required: true, message: '请选择奖项', trigger: 'change' }]"
      >
        <el-radio-group v-model="ruleForm.ApplyAwardTypeNames">
          <el-radio
            v-for="item in applyAwardTypeList"
            :label="item.Name"
            :key="item.Name"
            >{{ item.Name }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <div style="text-align: center; font-size: 12px; margin: 0 12%">
        <strong></strong>
      </div>
      <div
        v-for="(item, index) in ruleForm.RegisterApplyAwardViewModels"
        :key="index"
      >
        <span class="spanTitle">{{ item.Title }}</span>
        <el-form-item
          :prop="'RegisterApplyAwardViewModels.' + index + '.ApplicantName'"
          class="is-required set-label"
          :rules="[
            { required: true, message: '请输入姓名', trigger: 'blur' },
            {
              min: 1,
              max: 50,
              message: '姓名长度在1到50个字符',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            placeholder="姓名"
            v-model="item.ApplicantName"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item
          :prop="'RegisterApplyAwardViewModels.' + index + '.Position'"
          class="is-required set-label"
          :rules="[
            { required: true, message: '请输入职位', trigger: 'blur' },
            {
              min: 1,
              max: 50,
              message: '职位长度在1到50个字符',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            placeholder="职位"
            v-model="item.Position"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item
          :prop="'RegisterApplyAwardViewModels.' + index + '.PhoneNumber'"
          class="is-required set-label"
          :rules="[
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^1\d{10}$/, message: '请输入正确的手机号' },
          ]"
        >
          <el-input
            placeholder="手机"
            v-model="item.PhoneNumber"
            clearable
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item
          :prop="'RegisterApplyAwardViewModels.' + index + '.Email'"
          class="is-required set-label"
          :rules="[
            { required: true, message: '请输入邮箱', trigger: 'blur' },
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-input
            placeholder="邮箱"
            v-model="item.Email"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
      </div>

      <div
        v-if="ruleForm.RegisterApplyAwardViewModels.length < 2"
        class="addWinningInfo"
      >
        <el-button type="primary" @click="btnAdd">添加领奖人</el-button>
      </div>

      <el-form-item style="text-align: center">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="addLoading"
          >提 交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  getApplyAwardTypeList,
  registerApplyAward,
  getDefaultActivityInfo,
  getSlyFuzzySearchList,
} from '../../api/api'
export default {
  data() {
    return {
      companyList: [], //{ companyName: '', companyCode: '' }
      selectLoading: false,
      isShow: 'hide', //show  hide
      addLoading: false,
      addWinningInfo: true,
      applyAwardTypeList: [], // 获奖类型
      ruleForm: {
        ActivityId: '',
        ActivityName: '',
        CompanyName: '',
        ApplyAwardTypeNames: [],
        RegisterApplyAwardViewModels: [
          {
            Title: '领奖人',
            Type: 0,
            ApplicantName: '',
            Position: '',
            Position: '',
            Email: '',
          },
          {
            Title: '陪同人',
            Type: 1,
            ApplicantName: '',
            Position: '',
            Position: '',
            Email: '',
          },
        ],
      },
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          registerApplyAward(this.ruleForm).then((res) => {
            console.log(res)
            if (res.data.success) {
              this.$router.push('/success')
            }
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },

    btnAdd() {
      this.ruleForm.RegisterApplyAwardViewModels.push({})
    },

    remoteMethod(query) {
      if (query !== '') {
        this.selectLoading = true
        let debItem = null
        if (debItem) {
          clearTimeout(debItem)
        }
        debItem = setTimeout(() => {
          getSlyFuzzySearchList(query).then((res) => {
            // console.log(res)
            if (res.data.success) {
              this.companyList = res.data.response.data.data
              this.selectLoading = false
            }
          })
        }, 2000)
      }
    },
  },
  mounted() {
    getDefaultActivityInfo().then((res) => { 
      if (res.data.success) {
        this.ruleForm.ActivityId = res.data.response.ActivityIDStr
        this.ruleForm.ActivityName = res.data.response.EA_Title
        const applyAwardDeadline = res.data.response.ApplyAwardDeadline
        if (new Date(applyAwardDeadline) < new Date()) {
          this.$message({
            message: '已停止报名',
            type: 'error',
          })
        } else {
          this.isShow = 'show'
        }
      } else {
        this.$message({
          message: res.data.msg,
          type: 'error',
        })
      }
    }),
      getApplyAwardTypeList().then((res) => {
        if (res.data.success) {
          this.applyAwardTypeList = res.data.response
        }
      })
  },
}
</script>

<style scoped>
.el-radio-button__inner,
.el-radio-group {
  line-height: 30px;
}
.set-label > .el-form-item__label {
  width: 30px !important;
}
.spanTitle {
  font-weight: bold;
}
.addWinningInfo {
  padding-left: 90px;
  margin-bottom: 30px;
}
.hide {
  display: none;
}
.show {
  display: block;
}
.register {
  width: 60%;
  margin: 0 auto;
  padding-bottom: 30px;
}
.h2 {
  margin: 30px auto;
  text-align: center;
}
.v-modal {
  position: absolute;
  left: 0;
  top: 0;
  background: none;
}
.divInfo {
  /* border: 1px solid #e1e1e1;
  padding: 5px; */
  position: relative;
}
.items {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 15px;
}
.items div + div {
  padding-right: 15px;
}
.items div.yx {
  padding-right: 0;
}
.items .jx {
  width: auto;
  padding-right: 15px;
}
.items .sf {
  width: auto;
}
.items .xm {
  width: auto;
}
.items .zw {
  width: auto;
}
.items .sj {
  width: auto;
}
.items .yx {
  width: auto;
}
.el-select {
  width: 100%;
}
@media (max-width: 800px) {
  .register {
    width: 94%;
  }
  .h2 {
    font-size: 18px;
  }
}
</style>
